import React, { useEffect } from "react";
import { connect } from "react-redux";
import cement from "../../../assets/images/cement.png";
import { get_order } from "../../../redux/actions/adminActions";

function OrderDetails({ prev, next, orderID, getOrder, accessToken, order, show_allocating = true}) {
  useEffect(() => {
    getOrder(orderID, accessToken, () => console.log("done"));
  }, [orderID]);

  return (
    <div>
      <div className="sectionHeight container mt-3">
        <h2
          className="sectionText--mid textIsBold isClickable alignOnly"
          onClick={prev}
        >
          <i class="ri-arrow-left-line mx-2"></i>
          Orders Details
        </h2>

        <div className="pt-3">
          <div className="hasBorder sectionText hasRadius p-3">
            <div className="spaceBetween">
              <div className="">
                <p className="mb-0">
                  Order Number:
                  <span className="textIsBold mx-2">{order.order_id}</span>
                </p>
              </div>

              <div className="">
                <div
                  className={`tag  ${
                    order.status === "Pending"
                      ? "pending"
                      : order.status === "Cancelled"
                      ? "declined"
                      : order.status === "Allocating"
                      ? "allocating"
                      : "done"
                  }`}
                >
                  {order.tx_status}
                </div>
              </div>
            </div>

            <div className="mt-1 sectionText--small textIsGray">
              <p className="mb-1">1 item</p>
              <p className="mb-1">Placed on {order.date}</p>
              <p className="mb-1">Total Amount: ₦{order.sub_total}</p>
            </div>
          </div>
        </div>

        {show_allocating ? (
          <>
            {order.status == "Allocating" ||
            order.status == "Allocated" ||
            order.status == "Delivered" ? (
              <div className="mt-3 hasBorder hasRadius p-3">
                <div className="d-flex justify-content-between hasBorder--bottom">
                  <h2 className="sectionText--mid pb-3">
                    {order.status == "Delivered"
                      ? "Supplier"
                      : "Re-allocating Supplier"}
                  </h2>
                  <div className="">
                    <div className="d-flex gap-1 bgGreen2 rounded-pill">
                      <span className="bg__green px-2 rounded-pill text-white small">
                        {order.default_supplier}
                      </span>
                      <span className="px-1 text-white small">of</span>
                      <span className="px-2 text-white small">
                        {order.total_suppliers}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="sectionHeight--short pt-2">
                  <div className="alignOnly sectionText">
                    <div className="">
                      <p className="mb-1 textIsGray">Business Name:</p>
                      <p className="mb-1 textIsGray">Supplier Name:</p>
                      <p className="mb-1 textIsGray">Business Address:</p>
                      <p className="mb-1 textIsGray">Supplier Phone Number:</p>
                    </div>

                    <div className=" mx-2">
                      <p className="mb-1 textIsBlack">
                        {order.allocated_to?.business_name}
                      </p>
                      <p className="mb-1 textIsBlack">
                        {order.allocated_to?.manager_name}
                      </p>
                      <p className="mb-1 textIsBlack">
                        {order.allocated_to?.business_address}
                      </p>
                      <p className="mb-1 textIsBlack">
                        {order.allocated_to?.phone_number}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </>
        ) : (
          ""
        )}

        <div className="pt-3">
          <div className="spaceBetween">
            <h2 className="sectionText--mid">Order Items</h2>

            {/* <div className="">
                  <button className="btn__filled sectionText textIsBold hasRadius" onClick={next}>See Status History</button>
              </div> */}
          </div>

          <div className="mt-3">
            <div className="alignOnly hasBorder--bottom pb-3">
              <div className="imgHolder--tiny">
                <img
                  src={order.product?.product_image[0]}
                  alt=""
                  className="w-100"
                />
              </div>
              <div className="sectionText mx-2">
                <p className="mb-0 textIsBold">{order.product?.product_name}</p>
                <div className="alignOnly sectionText pt-1">
                  <p className="textIsGray  hasBorder--right mb-0">
                    Quantity:
                    <span className="textIsBold textIsBlack mx-1">
                      {order.quantity}
                    </span>
                  </p>
                  <p className="textIsGray  hasBorder--right mb-0 px-2">
                    Handling cost:
                    <span className="textIsBold textIsBlack mx-1">
                      ₦{order.handling_cost}
                    </span>
                  </p>
                  <p className="textIsGray mb-0 px-2">
                    Total:
                    <span className="textIsBold textIsBlack mx-1">
                      ₦{order.sub_total}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-3 hasBorder hasRadius p-3">
            <h2 className="sectionText--mid hasBorder--bottom pb-3 textIsBold">
              Payment Information
            </h2>

            <div className="sectionHeight--short pt-2">
              <div className="row">
                <div className="sectionText">
                  <p className="textIsGray mb-0 textIsBold">Payment Details:</p>

                  <div className="spaceBetween-alt mt-2 gap-3">
                    <p className="mb-0 textIsGray">Items Name:</p>
                    <p className="mb-0 textIsBold sectionText--mid">
                      {order.product?.product_name}
                    </p>
                  </div>

                  <div className="spaceBetween-alt mt-2 gap-3">
                    <p className="mb-0 textIsGray">Unit Cost:</p>
                    <p className="mb-0 textIsBold sectionText--mid">
                      ₦{order.unit_cost}
                    </p>
                  </div>

                  <div className="spaceBetween-alt mt-2 gap-3">
                    <p className="mb-0 textIsGray">No. of Items:</p>
                    <p className="mb-0 textIsBold sectionText--mid">
                      {order.quantity}
                    </p>
                  </div>

                  <div className="spaceBetween-alt mt-2 gap-3">
                    <p className="mb-0 textIsGray">Product Cost:</p>
                    <p className="mb-0 textIsBold sectionText--mid">
                      ₦{order.items_total}
                    </p>
                  </div>

                  <div className="spaceBetween-alt mt-2 gap-3">
                    <p className="mb-0 textIsGray">Handling Cost:</p>
                    <p className="mb-0 textIsBold sectionText--mid">
                      ₦{order.handling_cost}
                    </p>
                  </div>

                  <div className="spaceBetween-alt mt-2 gap-3">
                    <p className="mb-0 textIsGray">Delivery Cost:</p>
                    <p className="mb-0 textIsBold sectionText--mid">
                      ₦ {order.delivery_cost}
                    </p>
                  </div>

                  <div className="spaceBetween-alt mt-2 gap-3">
                    <p className="mb-0 textIsGray">Total Cost:</p>
                    <p className="mb-0 textIsBold sectionText--mid">
                      ₦ {order.sub_total}
                    </p>
                  </div>

                  <div className="sectionText spaceBetween-alt gap-3">
                    <p className="textIsGray mb-0">Payment Method:</p>
                    <p className="mb-0 mt-2 textIsBold sectionText--mid">
                      {order.payment_method}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-3 hasBorder hasRadius p-3">
            <h2 className="sectionText--mid hasBorder--bottom pb-3">
              Delivery Information
            </h2>

            <div className="sectionHeight--short pt-2">
              <div className="alignOnly sectionText">
                <div className="">
                  <p className="mb-1 textIsGray">Address:</p>
                  <p className="mb-1 textIsGray">Coordinates:</p>
                  <p className="mb-1 textIsGray">Name:</p>
                  <p className="mb-1 textIsGray">Mobile:</p>
                </div>

                <div className=" mx-2">
                  <p className="mb-1 textIsBlack">
                    {order.delivery_details?.address}
                  </p>
                  <p className="mb-1 textIsBlack">
                    {order.delivery_details?.long_cordinate}{" "}
                    {order.delivery_details?.lat_cordinate}
                  </p>
                  <p className="mb-1 textIsBlack">
                    {order.delivery_details?.receivers_name}
                  </p>
                  <p className="mb-1 textIsBlack">
                    +{order.delivery_details?.phone_number}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="pt-4">
            <h2 className="sectionText--mid hasBorder--bottom pb-3">
              Order History
            </h2>
            {order.order_history &&
              order.order_history.map((history) => (
                <div className="d-flex isRelative status pt-4">
                  <div className="icon--small">
                    <i className="ri-check-line"></i>
                  </div>

                  <div className="mx-2">
                    <h2 className="sectionText--mid mb-1 text-capitalize">
                      Order {history?.status}
                    </h2>
                    <p className="mb-0 sectionText textIsGray">
                      {history?.date}
                    </p>
                  </div>

                  <hr />
                </div>
              ))}
          </div>
          <div className="mt-4">
            <h2 className="sectionText--mid hasBorder--bottom pb-3">
              Proof Of Delivery
            </h2>
            {order.selected_suppliers &&
              order.selected_suppliers[0] &&
              order.selected_suppliers[0].pod && (
                <div className="grid grid-col-2 gap-4">
                  {order.selected_suppliers[0].pod.map((img) => (
                    <div className="p-2">
                      <a href={img} target="_blank">
                        <img
                          className="h-10 w-10"
                          height={220}
                          width={340}
                          src={img}
                        />
                      </a>
                    </div>
                  ))}
                </div>
              )}
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  order: state.admin.order,
  accessToken: state.admin.token,
});

const mapDispatchToProps = (dispatch) => ({
  getOrder: (id, token, success) => dispatch(get_order(id, token, success)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetails);
